import { useToast } from '~/components/ui/toast'

export default defineNuxtRouteMiddleware(async (to, _from) => {
  if (import.meta.server || !to.query.companyId) return

  const { selectCompany } = useCompanies()
  const { state: userState, fetchPermissionsForUser } = useUser()
  const { toast } = useToast()

  if (!userState.value.user) return

  const doesUserHaveAccess = userState.value.user?.companies.some(company => company.id === Number(to.query.companyId))
  if (doesUserHaveAccess) {
    await selectCompany(to.query.companyId as string)
    await fetchPermissionsForUser(userState.value.user?.id as number, to.query.companyId as string)
  } else {
    toast({
      title: 'You do not have access to this company',
      variant: 'destructive',
    })
  }
})
